import { Component, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Asset } from 'app/classes/asset';
import { BuildingReview } from 'app/classes/building-review';
import { IAssetContainer } from 'app/insights/reviews/insights-review-item/insights-review-item.component';
import { BuildingsService } from 'app/shared/buildings.service';

@Component({
  selector: 'app-automation-review',
  templateUrl: './automation-review.component.html',
  styleUrl: './automation-review.component.css',
  standalone: false
})
export class AutomationReviewComponent {
  review = signal<BuildingReview>(null);
  assets = signal<IAssetContainer[]>(null);
  telemetry = signal<any>([]);
  start: string;
  token: string;
  hasFailed = false;
  assetCount: number;
  assetsLoaded = signal<number>(0);
  isLoadingData = signal<boolean>(true);

  constructor(private titleService: Title, private activatedRoute: ActivatedRoute, private buildingService: BuildingsService) {
    this.token = activatedRoute.snapshot.params.tokenid;

    // Must have these inputs
    if (!this.token) {
      this.hasFailed = true;
    } else {
      console.log(`Recievied parameters`, this.token);
      this.titleService.setTitle(`please wait`);
      this.buildingService.getReviewForAutomation(this.token).then(review => {
        const buildingReview = new BuildingReview(review);

        this.assets.set(review.assets.map(a => { return { asset: new Asset({ id: a.id, title: a.title, assetType_id: a.assetType_id }), telemetry: null, state: 'pending', annotation: { rag: 'green', text: '' } } }));


        review.annotations.sort((a, b) => a.rag === 'red' ? -2 : a.rag === 'amber' ? -1 : 1);

        review.annotations.forEach(a => {
          const asset = this.assets().find(asset => asset.asset.id === a.asset_id);
          if (asset) {
            asset.annotation = { rag: a.rag, text: a.annotation };
          }
        });
        this.review.set(buildingReview);

        this.initialiseReview();
      });
    }
  }

  getDates() {
    const start = this.review().review.dates.start;
    const end = this.review().review.dates.end;

    return { start, end };
  }

  initialiseReview() {
    this.assetCount = this.assets.length;
    this.assetsLoaded.set(0);
    this.getTelemetry();
  }

  getTelemetry() {
    const getAsset = this.assets().find(a => a.state === 'pending');
    console.log(`getasset`, getAsset);
    if (!getAsset) {
      this.assetsLoaded.set(this.assetCount);
      this.isLoadingData.set(false);
      this.titleService.setTitle(`u_10_b_${this.review().building.id}_d_${+this.review().review.dates.start}_review.pdf`);

      return;
    }

    this.buildingService.getReviewTelemetryForAutomation(this.token, getAsset.asset.id, this.review().review.dates.start, this.review().review.dates.end).then((response: any) => {
      getAsset.state = 'hasdata';
      this.assetsLoaded.set(this.assetsLoaded() + 1);

      const assets = this.assets();

      const index = this.assets().findIndex(a => a.asset.id === getAsset.asset.id);

      this.assets[index] = { ...getAsset, telemetry: response.telemetry };
      console.log(this.assets[index].telemetry)
      this.assets.set(null);
      setTimeout(() => {
        this.assets.set(assets);

        const t = this.telemetry();

        t.push({ asset: getAsset.asset, annotation: getAsset.annotation, telemetry: response.telemetry });

        this.telemetry.set(t);

        console.log(`telemetry`, this.telemetry());
        setTimeout(() => {
          this.getTelemetry();
        }, 100);
      }, 100);

    });
  }
}
